import * as React from "react"
import MenuItem from "@mui/material/MenuItem"
import ListItemIcon from "@mui/material/ListItemIcon"
import Divider from "@mui/material/Divider"
import Typography from "@mui/material/Typography"
import Logout from "@mui/icons-material/Logout"
import { Popover, PopoverProps, Stack } from "@mui/material"
import ThemeSwitch from "src/shared/container/theme-switch"
import { useNavigate } from "react-router-dom"
import { useTypedDispatch } from "src/shared/store/store"
import { logoutState } from "src/shared/store/slices/auth/auth"
import ROUTE_PATHS from "src/routes/route-path"

export default function AccountMenu({ onClose, ...rest }: PopoverProps & { onClose: () => void }) {
  const navigate = useNavigate()
  const dispatch = useTypedDispatch()
  const handleLogout = () => {
    dispatch(logoutState())
    onClose()
    navigate(ROUTE_PATHS.LOGIN)
  }
  return (
    <React.Fragment>
      <Popover
        onClose={onClose}
        {...rest}
        slotProps={{
          paper: {
            sx: {
              "&.MuiPaper-root": {
                width: "240px",
                // maxWidth: "300px",
                p: 1,
                overflow: "hidden"
              }
            }
          }
        }}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} px={1} mb={1}>
          <Typography variant="body1" fontWeight={600}>
            Theme
          </Typography>
          <ThemeSwitch />
        </Stack>
        <Divider sx={{ mb: 1 }} />
        <MenuItem onClick={() => handleLogout()}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Popover>
    </React.Fragment>
  )
}
